module.exports = __webpack_public_path__ + "media/images/left-3adfe7ac97f73ce271755140ed09e9a7.jpg";